import * as React from "react";

import primaryColour from "../../constants";

function SvgGeofenceenter(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.99998 4.81885C8.50292 4.81885 8.09998 5.22179 8.09998 5.71885C8.09998 6.2159 8.50292 6.61885 8.99998 6.61885H14.25C14.8575 6.61885 15.35 7.11133 15.35 7.71885V16.0313C15.35 16.6389 14.8575 17.1313 14.25 17.1313H8.99998C8.50292 17.1313 8.09998 17.5343 8.09998 18.0313C8.09998 18.5284 8.50292 18.9313 8.99998 18.9313H14.25C15.8516 18.9313 17.15 17.633 17.15 16.0313V7.71885C17.15 6.11722 15.8516 4.81885 14.25 4.81885H8.99998Z"
        fill={fill}
      />
      <path
        d="M3.15623 11.1626C2.65917 11.1626 2.25623 11.5655 2.25623 12.0626C2.25623 12.5597 2.65917 12.9626 3.15623 12.9626H9.913L8.55877 14.3168C8.2073 14.6683 8.2073 15.2381 8.55877 15.5896C8.91024 15.9411 9.48009 15.9411 9.83156 15.5896L12.655 12.7662C12.8615 12.6013 12.9937 12.3474 12.9937 12.0626C12.9937 12.0495 12.9934 12.0365 12.9929 12.0235C13.0033 11.7804 12.9157 11.5339 12.7301 11.3483L9.83155 8.44987C9.48007 8.09841 8.91022 8.09842 8.55876 8.4499C8.20729 8.80138 8.2073 9.37122 8.55878 9.72269L9.99875 11.1626H3.15623Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgGeofenceenter;
